import type { SVGProps } from "react";
export const DogTourPointerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 52 30"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.18 23.172 24.35 0h27v30H4.008C.444 30-1.34 25.691 1.18 23.172"
    />
  </svg>
);
